<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>积分商城->积分兑换</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:250px;">
                    <el-input v-model="form.queryUserNames" placeholder="兑换用户" :readonly="true">
                        <el-button slot="append" icon="el-icon-search"  @click="findUser()"></el-button>
                    </el-input>
                </div>
            </div>
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            <el-button type="primary" @click="exportExcel">导出Excel</el-button>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                height="550"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="兑换用户" :show-overflow-tooltip="true" width="80px">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="showData(scope.row.createBy)">{{scope.row.name}}</el-link>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="commonName" label="所属机构" width="100px"></el-table-column> -->
                <el-table-column prop="exchangeGoldnum" label="兑换金币" width="130px"></el-table-column>
                <el-table-column prop="deductIntegralnum" label="扣除积分数量" width="130px"></el-table-column>
                <el-table-column prop="gmtCreate" label="兑换时间" width="150px"></el-table-column>
                <el-table-column prop="title" label="兑换描述" ></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!--详情 -->
        <div v-if="userDetailsVisible">
            <userDetails ref="userDetails"></userDetails>
        </div>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http'; 
    import userDetails from '../order/UserDetails.vue';
    import userTransfer from '../../sys/user/UserTransfer.vue' 
    import { readonly } from 'vue';

    export default {
        name:"CommodityList",
        data(){
            return{
                loading:false,
                loadingText:"",

                userDetailsVisible:false,
                transferVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    queryUserIds:"",
                    queryUserNames:"",
                },
                data:[],
                depts:[]
            }
        },
        components: {
            userDetails, userTransfer
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中..."

                // 获取查询条件参数
                let userIds=this.$util.isEmpty(this.form.queryUserIds)?"":this.form.queryUserIds.join(',')

                let url  = this.commodityIntegralExchangeGoldListUrl
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    deptId:this.form.deptId,
                    createBy:userIds,
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                       this.common.total=res.data.total;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            showData(val){
                let url  = this.getUserUrl;
                let data = {
                   id:val
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // 触发详情界面
                        this.userDetailsVisible = true;
                        this.$nextTick(() => {
                            this.$refs['userDetails'].init(res.data);
                        })
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
                
            },
            findUser(){
                this.transferVisible=true;
                this.$nextTick(() => { 
                    if(this.form.queryUserIds.length > 0){
                        this.$refs['userTransfer'].init(1,this.form.queryUserIds,2,this.form.deptId)
                    }else{
                        this.$refs['userTransfer'].init(1,null,2,this.form.deptId)
                    }
                })
            },
            setUser(keyArr,nameArr){
                console.log('ID：',keyArr,"姓名：",nameArr)
                if(keyArr.length == 0){
                    this.form.queryUserIds=""
                    this.form.queryUserNames=""
                }else{
                    this.form.queryUserIds=keyArr
                    this.form.queryUserNames=nameArr.join(',')
                }
            },
            exportExcel(){
                let msg="导出数据只支持导出1W条，超出会导出失败，请确认当前页面总条数！";
                this.$commonFn.showConfirm2(msg,this.exportData);
            },
            exportData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";
                let url=this.commodityIntegralExchangeGoldExportExcelUrl;

                let userIds=this.$util.isEmpty(this.form.queryUserIds)?"":this.form.queryUserIds.join(',')

                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('createBy', userIds);

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '积分兑换.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error); 
                    this.loading=false;
                });
           }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/shop/exchange/ExchangeGold.vue